import React, { Component } from 'react';
import { LevThreeThree, LevThreeFive, LevThreeSix, LevThreeTwo } from './LevelThree';

class LevelThree extends Component {
    render() {
        return (
            <div>
                {/* <LevThreeThree /> */}
                { this.props.gridNumber === 2 && <LevThreeTwo /> }
                { this.props.gridNumber === 3 && <LevThreeThree /> }
                { this.props.gridNumber === 5 && <LevThreeFive /> }
                { this.props.gridNumber === 6 && <LevThreeSix /> }
            </div>
        );
    }
}

export default LevelThree;